<template>
  <div class="jianjie-page">
    <!-- 页面头部 -->
    <div class="header">
      <div class="header-left" @click="goBack">
        <svg width="35" height="35" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="header-title">平台简介</div>
      <div class="header-right"></div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area">
      <div v-if="loading" class="loading">
        加载中...
      </div>
      <div v-else-if="error" class="error">
        {{ error }}
      </div>
      <div v-else class="rich-content" v-html="jianjieContent"></div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'JianjiePage',
  data() {
    return {
      jianjieContent: '',
      loading: true,
      error: null
    }
  },
  mounted() {
    this.getJianjieContent();
  },
  methods: {
    // 获取简介内容
    async getJianjieContent() {
      try {
        this.loading = true;
        this.error = null;
        
        const response = await request.get("/api/index/jianjie");
        console.log('简介接口返回:', response);
        
        if (response && response.code === 1 && response.data) {
          this.jianjieContent = response.data.jianjie || '暂无内容';
        } else {
          this.error = response.msg || '获取内容失败';
        }
      } catch (error) {
        console.error('获取简介内容失败:', error);
        this.error = '网络错误，请重试';
      } finally {
        this.loading = false;
      }
    },
    
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="less" scoped>
.jianjie-page {
  min-height: 100vh;
  background: #050925;
  color: white;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.18rem 0.3rem;
  background: #161936;
  
  .header-left {
    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .header-title {
    font-size: 0.48rem;
    font-weight: 500;
    color: white;
  }
  
  .header-right {
    width: 1rem;
    height: 1rem;
  }
}

.content-area {
  padding: 0.5rem;
  
  .loading {
    text-align: center;
    font-size: 0.4rem;
    color: #999;
    padding: 2rem 0;
  }
  
  .error {
    text-align: center;
    font-size: 0.4rem;
    color: #ef4444;
    padding: 2rem 0;
  }
  
  .rich-content {
    font-size: 0.4rem;
    line-height: 1.6;
    color: white;
    
    // 富文本内容样式
    :deep(p) {
      margin-bottom: 0.4rem;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    :deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
      margin: 0.6rem 0 0.4rem 0;
      font-weight: 600;
      color: white;
    }
    
    :deep(h1) { font-size: 0.6rem; }
    :deep(h2) { font-size: 0.55rem; }
    :deep(h3) { font-size: 0.5rem; }
    :deep(h4) { font-size: 0.45rem; }
    :deep(h5) { font-size: 0.42rem; }
    :deep(h6) { font-size: 0.4rem; }
    
    :deep(ul), :deep(ol) {
      margin: 0.4rem 0;
      padding-left: 0.8rem;
      
      li {
        margin-bottom: 0.2rem;
      }
    }
    
    :deep(blockquote) {
      margin: 0.4rem 0;
      padding: 0.4rem;
      background: #161936;
      border-left: 0.1rem solid #ef4444;
      border-radius: 0.1rem;
    }
    
    :deep(code) {
      background: #161936;
      padding: 0.1rem 0.2rem;
      border-radius: 0.1rem;
      font-family: 'Courier New', monospace;
      font-size: 0.35rem;
    }
    
    :deep(pre) {
      background: #161936;
      padding: 0.4rem;
      border-radius: 0.1rem;
      overflow-x: auto;
      margin: 0.4rem 0;
      
      code {
        background: none;
        padding: 0;
      }
    }
    
    :deep(img) {
      max-width: 100%;
      height: auto;
      border-radius: 0.1rem;
      margin: 0.4rem 0;
    }
    
    :deep(table) {
      width: 100%;
      border-collapse: collapse;
      margin: 0.4rem 0;
      
      th, td {
        border: 1px solid #333;
        padding: 0.3rem;
        text-align: left;
      }
      
      th {
        background: #161936;
        font-weight: 600;
      }
    }
    
    :deep(a) {
      color: #ef4444;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
    
    :deep(strong), :deep(b) {
      font-weight: 600;
    }
    
    :deep(em), :deep(i) {
      font-style: italic;
    }
    
    :deep(hr) {
      border: none;
      border-top: 1px solid #333;
      margin: 0.6rem 0;
    }
  }
}
</style>